/**
 * Shared MIME type constants.
 */

/** CSV export (UTF-8), used when the browser downloads a `.csv`. */
export const CSV_MIME = 'text/csv;charset=utf-8;';

/** Office Open XML Spreadsheet (.xlsx) — exports and import templates. */
export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
